import type { StudioUser } from "./types";
import { userInitials } from "./userDisplay";

export function UserAvatar({
  user,
  className = "avatar",
}: {
  user: StudioUser | null;
  className?: string;
}) {
  if (user?.picture) {
    return (
      <img
        className={className}
        src={user.picture}
        alt=""
        referrerPolicy="no-referrer"
        title={user.name || user.email}
      />
    );
  }
  return (
    <div className={className} title={user?.name || user?.email || undefined}>
      {userInitials(user)}
    </div>
  );
}
